import { Component, OnInit } from '@angular/core';
import { EntitlementService } from '../../services/entitlement.service';
import { CardholderService } from '../../services/cardholder.service';
import { ProfileSearchResult } from '../../data/ProfileSearchResult';
import { MessageService } from '../../services/message.service';
import { ACHFundingInfo } from '../../data/ACHFundingInfo';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { AchRequest } from '../../data/AchRequest';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import * as customValidator from '../../validators/cardholder-validator';
import { NCConstants } from '../../data/NCConstants';
import { FormUtils } from 'src/app/FormUtils';
import { ReplenishMethods } from 'src/app/data/ReplenishMethods';
import {CardholderDetails} from "../../data/CardholderDetails";
import {Card} from "../../data/Card";

@Component({
  selector: 'app-achfunding',
  templateUrl: './achfunding.component.html',
  styleUrls: ['./achfunding.component.css']
})
export class AchfundingComponent implements OnInit {
  cardholder: ProfileSearchResult;
  save_ach_btn = false;
  save_ach_btn_spinner = '';
  achfundingInfo: ACHFundingInfo;
  achDeclineCountNewOption: number;
  bankAccountNumberPlaceholder: string;
  saveStatus = '';
  startDate: NgbDate;
  endDate: NgbDate;
  achFunds: AchRequest[] = [];
  achFundForm: UntypedFormGroup;
  chipOnly: boolean;
  cardsAccount: Card[];
  achValues = ['Y', 'N'];
  isActiveValues = [{ value: 'Y', label: 'ACTIVE' }, { value: 'N', label: 'INACTIVE' }]

  fundRefunds = [
    {
      id: 'N',
      value: 'Not Requested'
    },
    {
      id: 'funding',
      value: 'Request Funding'
    },
    {
      id: 'refund',
      value: 'Request Refund'
    }
  ];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private calendar: NgbCalendar,
    private entitlementService: EntitlementService,
    private cardHolderService: CardholderService,
    private messageService: MessageService,
    private formUtils: FormUtils
  ) { }

  ngOnInit() {
    this.cardholder = CardholderService.retrieveCardholder();
    this.loadPageData();
  }

  loadPageData() {
    this.endDate = this.calendar.getToday();
    this.startDate = this.calendar.getToday();
    const startDateWork = new Date();
    startDateWork.setDate(startDateWork.getDate() - 90);
    this.startDate = new NgbDate(
      startDateWork.getFullYear(),
      startDateWork.getMonth() + 1,
      1
    );

    this.cardHolderService
      .getAchfundingInfo(this.cardholder.payrollAccount)
      .subscribe(
        (data: ACHFundingInfo) => {
          this.achfundingInfo = data;
          if (
            this.achfundingInfo.customerAccount.achDeclineCount != 0 &&
            this.achfundingInfo.customerAccount.achDeclineCount != 99
          ) {
            this.achDeclineCountNewOption = this.achfundingInfo.customerAccount.achDeclineCount;
          }

          if (
            null != this.achfundingInfo.replenishMethods &&
            this.achfundingInfo.replenishMethods.srcAcctNum != undefined
          ) {
            this.bankAccountNumberPlaceholder = this.achfundingInfo.replenishMethods.srcAcctNum;
          }

          if (this.achfundingInfo.replenishMethods === undefined || this.achfundingInfo.replenishMethods === null) {
            const replenish = <ReplenishMethods>{};
            replenish.isActive = 'N';
            replenish.srcAcctName = '';
            replenish.srcABANum = '';
            replenish.srcAcctNum = '';
            replenish.srcAcctType = '';
            replenish.srcORGType = '';

            this.achfundingInfo.replenishMethods = replenish;
          } else if (this.achfundingInfo.replenishMethods.isActive === null) {
            this.achfundingInfo.replenishMethods.isActive = 'N';
          }

          this.achfundingInfo.fundRefund = 'N';
          this.initForm();
          this.reloadAchHistory();
        },
        error => {
          this.messageService.error(
            'Error loading the ACH Funding Info: ' + error.data
          );
        },
        () => {
          this.cardHolderService.getCardholderDetails(this.achfundingInfo.customerAccount.account).subscribe(
            (data: CardholderDetails) => {
              this.cardsAccount = data.cardList;
            },
            (error) => {
              this.messageService.error('Error finding card holder details: ' + error);
            },
            () => {
              this.checkChipOnly();
              this.cardHolderService.chipDetails(this.chipOnly);
            }
          )
        }
      );
  }

  initForm() {
    this.achFundForm = this.formBuilder.group({
      achAllowed: ['', []],
      status: ['', []],
      achDeclineCount: ['', []],
      srcAcctName: ['', []],
      srcABANum: ['', []],
      srcAcctNum: ['', []],
      srcAcctType: ['', []],
      srcORGType: ['', []],
      srcAcctBankCity: ['', []],
      srcAcctBankState: ['', []],
      srcAcctBankZip: ['', []],
      fundRefund: ['', []],
      fundAmt: [
        '',
        [
          customValidator.requestingAmountValidator(
            this.achfundingInfo.fundRefund
          )
        ]
      ],
      tranMinDate: [this.startDate, []],
      tranMaxDate: [this.endDate, []]
    });

    this.loadFormData();
  }

  loadFormData() {
    this.achFundForm
      .get('achAllowed')
      .patchValue(this.achfundingInfo.customerAccount.achAllowed);
    this.achFundForm
      .get('achDeclineCount')
      .patchValue(this.achfundingInfo.customerAccount.achDeclineCount);
    this.achFundForm
      .get('fundRefund')
      .patchValue(this.achfundingInfo.fundRefund);
    this.achFundForm.get('fundAmt').patchValue(this.achfundingInfo.fundAmt);

    if (this.achfundingInfo.bankAddress !== null) {
      this.achFundForm
        .get('srcAcctBankCity')
        .patchValue(this.achfundingInfo.bankAddress.city);
      this.achFundForm
        .get('srcAcctBankState')
        .patchValue(this.achfundingInfo.bankAddress.state);
      this.achFundForm
        .get('srcAcctBankZip')
        .patchValue(this.achfundingInfo.bankAddress.zip);
    }

    if (this.achfundingInfo.replenishMethods) {
      this.achFundForm
        .get('status')
        .patchValue(this.achfundingInfo.replenishMethods.isActive);
      this.achFundForm
        .get('srcAcctName')
        .patchValue(this.achfundingInfo.replenishMethods.srcAcctName);
      this.achFundForm
        .get('srcABANum')
        .patchValue(this.achfundingInfo.replenishMethods.srcABANum);
      this.achFundForm
        .get('srcAcctNum')
        .patchValue(this.achfundingInfo.replenishMethods.srcAcctNum);
      this.achFundForm
        .get('srcAcctType')
        .patchValue(this.achfundingInfo.replenishMethods.srcAcctType);
      this.achFundForm
        .get('srcORGType')
        .patchValue(this.achfundingInfo.replenishMethods.srcORGType);
    }

    this.achFundForm.controls['achAllowed'].valueChanges.subscribe((val) => {
      this.achfundingInfo.customerAccount.achAllowed = val;
      if (this.achfundingInfo.replenishMethods === null) {
        this.achfundingInfo.replenishMethods = {
          isActive: 'N'
        }
      }
      if (val === 'N') {
        this.achFundForm.controls['srcAcctName'].clearValidators();
        this.achFundForm.controls['srcAcctName'].updateValueAndValidity();
        this.achFundForm.controls['srcABANum'].clearValidators();
        this.achFundForm.controls['srcABANum'].updateValueAndValidity();
        this.achFundForm.controls['srcAcctNum'].clearValidators();
        this.achFundForm.controls['srcAcctNum'].updateValueAndValidity();
      } else {
        this.achFundForm.controls['srcAcctName'].setValidators([
          customValidator.srcAcctNameValidator,
          Validators.required,
          Validators.maxLength(22)
        ]);
        this.achFundForm.controls['srcAcctName'].updateValueAndValidity();
        this.achFundForm.controls['srcABANum'].setValidators([
          customValidator.routingNumberValidator,
          Validators.required,
          Validators.maxLength(9)
        ]);
        this.achFundForm.controls['srcABANum'].updateValueAndValidity();
        this.achFundForm.controls['srcAcctNum'].setValidators([
          customValidator.srcAcctNumValidator,
          Validators.required,
          Validators.maxLength(16)
        ]);
        this.achFundForm.controls['srcAcctNum'].updateValueAndValidity();
      }
    });
    this.achFundForm.controls['status'].valueChanges.subscribe((val) => {
      this.achfundingInfo.replenishMethods.isActive = val;
    });
  }

  get formHandle() {
    return this.achFundForm.controls;
  }

  showNewCardholder(newCardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(newCardholder);
    this.cardholder = newCardholder;
    this.loadPageData();
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  changeStartDate(newDate) {
    if (newDate.srcElement) {
      const tempDate = new Date(newDate.srcElement.value);
      this.startDate = new NgbDate(
        tempDate.getFullYear(),
        tempDate.getMonth() + 1,
        tempDate.getDate()
      );
    } else {
      this.startDate = newDate;
    }
    this.reloadAchHistory();
  }

  changeEndDate(newDate) {
    if (newDate.srcElement) {
      const tempDate = new Date(newDate.srcElement.value);
      this.endDate = new NgbDate(
        tempDate.getFullYear(),
        tempDate.getMonth() + 1,
        tempDate.getDate()
      );
    } else {
      this.endDate = newDate;
    }
    this.reloadAchHistory();
  }

  reloadAchHistory() {
    const startDateString =
      this.startDate.month +
      '/' +
      this.startDate.day +
      '/' +
      this.startDate.year;
    const endDateString =
      this.endDate.month + '/' + this.endDate.day + '/' + this.endDate.year;
    this.cardHolderService
      .showAchRequestHistory(
        this.cardholder.payrollAccount,
        startDateString,
        endDateString
      )
      .subscribe(
        (data: AchRequest[]) => {
          this.achFunds = data;
        },
        error => {
          this.messageService.error('Error getting ACH history: ' + error.data);
        }
      );
  }

  updateAchFundingInfo() {
    this.achfundingInfo.customerAccount.achAllowed = this.achFundForm.controls[
      'achAllowed'
    ].value;
    this.achfundingInfo.replenishMethods.isActive = this.achFundForm.controls[
      'status'
    ].value;
    this.achfundingInfo.customerAccount.achDeclineCount = this.achFundForm.controls[
      'achDeclineCount'
    ].value;
    this.achfundingInfo.replenishMethods.srcAcctName = this.achFundForm.controls[
      'srcAcctName'
    ].value;
    this.achfundingInfo.replenishMethods.srcABANum = this.achFundForm.controls[
      'srcABANum'
    ].value;
    this.achfundingInfo.replenishMethods.srcAcctNum = this.achFundForm.controls[
      'srcAcctNum'
    ].value;
    this.achfundingInfo.replenishMethods.srcAcctType = this.achFundForm.controls[
      'srcAcctType'
    ].value;
    this.achfundingInfo.replenishMethods.srcORGType = this.achFundForm.controls[
      'srcORGType'
    ].value;
    this.achfundingInfo.fundAmt = this.achFundForm.controls['fundAmt'].value;
    // this.achfundingInfo.bankAddress.city  = this.achFundForm.controls['srcAcctBankCity'].value;
    // this.achfundingInfo.bankAddress.state = this.achFundForm.controls['srcAcctBankState'].value;
    // this.achfundingInfo.bankAddress.zip = this.achFundForm.controls['srcAcctBankZip'].value;
  }

  saveAchFunds() {
    this.formUtils.markFormFieldsAsTouched(this.achFundForm);
    if (!this.achFundForm.valid) {
      return false;
    }
    this.updateAchFundingInfo();
    this.save_ach_btn_spinner = 'fa fa-spinner';
    this.save_ach_btn = true;
    this.cardHolderService
      .checkDuplicateACHAccount(
        this.cardholder.payrollAccount,
        this.achfundingInfo
      )
      .subscribe(
        () => {
          this.cardHolderService
            .updateACHFundingInfo(
              this.cardholder.payrollAccount,
              this.achfundingInfo
            )
            .subscribe(
              () => {
                this.save_ach_btn_spinner = '';
                this.save_ach_btn = false;
                this.messageService.success('Successfully saved ACH details');
                this.loadPageData();
              },
              error => {
                this.save_ach_btn_spinner = '';
                this.save_ach_btn = false;
                if (
                  error.status ===
                  NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE
                ) {
                  this.messageService.error(error.error);
                } else {
                  this.messageService.error(error.message);
                }
              }
            );
        },
        error => {
          this.save_ach_btn_spinner = '';
          this.save_ach_btn = false;
          if (error.status === NCConstants.HTTP_STATUS_I_AM_A_TEAPOT) {
            const that = this;
            this.save_ach_btn_spinner = '';
            this.save_ach_btn = false;
            if (
              confirm(
                'Banking information is already linked to another Navy Cash account.\n Do you still want to update the banking information?'
              )
            ) {
              this.cardHolderService
                .updateACHFundingInfo(
                  this.cardholder.payrollAccount,
                  this.achfundingInfo
                )
                .subscribe(
                  () => {
                    that.messageService.success(
                      'Successfully saved ACH details'
                    );
                    that.loadPageData();
                  },
                  otherError => {
                    if (
                      otherError.status ===
                      NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE
                    ) {
                      this.messageService.error(otherError.error);
                    } else {
                      this.messageService.error(otherError.message);
                    }
                  }
                );
            }
          } else if (
            error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE
          ) {
            this.messageService.error(error.error);
          } else {
            this.messageService.error(
              'Error updating the ACH Funding: ' + error.message
            );
          }
        }
      );
    return;
  }

  checkChipOnly() {
    const index = this.cardsAccount.findIndex(x => x.type !== 'CHIP');
    this.chipOnly = index < 0;
  }
}
